<template>
<div>
 <ConfirmationBar
    :showSavebar="showSavebar"
    @confirm="saveData"
    @cancel="cancel"
  />
  <div class="full-page-width relative locations">
    <div class="row">
      <div class="col-xs-4 sticky-100">
        <div class="flex-center m-b-40 h-40">
          <div class="flex-center">
            <Btn
              v-if="nameAndBackOption"
              @click.native="routeIt"
              class="light bordered empty d-inline-block m-r-15 fix-40"
              :icon="{
                name: 'arrowLeftBig',
                size: '20',
              }" />
            <p class="user-name">{{ $t('Profile') }}</p>
          </div>
        </div>
        <UserCard @openPopupEdit="openEditPopup" :isEditable="isEditableProfile" />
      </div>
      <div class="col-xs-8">
        <div v-if="(get_user.is_admin && !get_stored_user.is_super_admin) || (get_user.is_system_user && !get_stored_user.is_system_user)">
          <h2 class="page-title heighted">{{ $t('general') }}</h2>
          <div class="m-b-40 card">
            <InputSelect
              :label="$t('User type')"
              v-model="userRole"
              :options="getUserRoleOptions"/>
          </div>
        </div>
        <h2 class="m-b-20 page-title">{{ $t('Dashboard') }}</h2>
        <div class="m-b-40 card">
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('overview')}}</p>
              <span>{{ $t('perm_overview_info_text')}}</span>
            </div>
            <div>
              <Toggle id="dashboard" v-model="userData.permissions.dashboard"/>
            </div>
          </div>
        </div>

        <h2 class="m-b-20 page-title">{{ $t('Shipments') }}</h2>
        <div class="m-b-40 card">
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('book_shipment')}}</p>
              <span>{{ $t('perm_book_shipment_info_text')}}</span>
            </div>
            <div>
              <Toggle id="shipment_book_shipment" v-model="userData.permissions.shipment_book_shipment"/>
            </div>
          </div>
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('all_shipments') }}</p>
              <span>{{  $t('perm_all_shipments_info_text') }}</span>
            </div>
            <div>
              <Toggle id="shipment_history" v-model="userData.permissions.shipment_history"/>
            </div>
          </div>
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('drafts') }}</p>
              <span>{{ $t('perm_drafts_info_text') }}</span>
            </div>
            <div>
              <Toggle id="shipment_drafts" v-model="userData.permissions.shipment_drafts"/>
            </div>
          </div>
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('eod_manifest') }}</p>
              <span>{{ $t('perm_eod_info_text') }}</span>
            </div>
            <div>
              <Toggle id="shipment_end_of_day" v-model="userData.permissions.shipment_end_of_day"/>
            </div>
          </div>
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('unapproved_shipments') }}</p>
              <span>{{ $t('perm_unapproved_shipments_info_text') }}</span>
            </div>
            <div>
              <Toggle id="unapproved_shipments" v-model="userData.permissions.unapproved_shipments"/>
            </div>
          </div>
          <div class="flex-center toggle-title" v-if="parseInt(get_user.backoffice_id) === 1">
            <div>
              <p>{{ $t('consolidations') }}</p>
              <span>{{ $t('consolidations-info-text') }}</span>
            </div>
            <div>
              <Toggle id="consolidations" v-model="userData.permissions.consolidations"/>
            </div>
          </div>
        </div>

        <h2 class="m-b-20 page-title">{{ $t('pickups') }}</h2>
        <div class="m-b-40 card">
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('booked_pickup') }}</p>
              <span>{{ $t('list_of_all_booked_pickups') }}</span>
            </div>
            <div>
              <Toggle id="booked-pickup" v-model="userData.permissions.booked_pickup"/>
            </div>
          </div>
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('not_planned_pickup') }}</p>
              <span>{{ $t('list_of_all_not_planned_pickups') }}</span>
            </div>
            <div>
              <Toggle id="not-planned-pickup" v-model="userData.permissions.not_planned_pickup"/>
            </div>
          </div>
        </div>

        <h2 class="m-b-20 page-title">{{ $t('Contacts') }}</h2>
        <div class="m-b-40 card">
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('overview')}}</p>
              <span>{{ $t('perm_contacts_info_text') }}</span>
            </div>
            <div>
              <Toggle id="customer" v-model="userData.permissions.customer"/>
            </div>
          </div>
        </div>

        <h2 class="m-b-20 page-title">{{ $t('Settings')}}</h2>
        <div class="m-b-40 card">
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('LBL_PAYERS') }}</p>
              <span>{{ $t('TXT_PAYER_INFO' )}}</span>
            </div>
            <div>
              <Toggle id="settings_payer" v-model="userData.permissions.settings_payer"/>
            </div>
          </div>
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('locations') }}</p>
              <span>{{ $t('perm_locations_info_text' )}}</span>
            </div>
            <div>
              <Toggle id="settings_sender" v-model="userData.permissions.settings_sender"/>
            </div>
          </div>
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('notifications') }}</p>
              <span>{{ $t('perm_notifications_info_text') }}</span>
            </div>
            <div>
              <Toggle id="settings_message" v-model="userData.permissions.settings_message"/>
            </div>
          </div>
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('automations') }}</p>
              <span>{{ $t('perm_automations_info_text') }}</span>
            </div>
            <div>
              <Toggle id="settings_automations" v-model="userData.permissions.settings_automations"/>
            </div>
          </div>
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('packaging') }}</p>
              <span>{{ $t('perm_packaging_info_text')}}</span>
            </div>
            <div>
              <Toggle id="settings_package" v-model="userData.permissions.settings_package"/>
            </div>
          </div>
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('upload_templates') }}</p>
              <span>{{ $t('perm_upload_templates_info_text') }}</span>
            </div>
            <div>
              <Toggle id="settings_import_template" v-model="userData.permissions.settings_import_template"/>
            </div>
          </div>
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('team') }}</p>
              <span>{{ $t('perm_team_info_text') }}</span>
            </div>
            <div>
              <Toggle id="settings_team" v-model="userData.permissions.settings_team"/>
            </div>
          </div>
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('printers') }}</p>
              <span>{{ $t('perm_printers_info_text') }}</span>
            </div>
            <div>
              <Toggle id="settings_printer" v-model="userData.permissions.settings_printer"/>
            </div>
          </div>
          <div class="flex-center toggle-title">
            <div>
              <p>SMTP</p>
              <span>{{ $t('perm_smtp_info_text') }}</span>
            </div>
            <div>
              <Toggle id="settings_smtp" v-model="userData.permissions.settings_smtp"/>
            </div>
          </div>
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('system') }}</p>
              <span>{{ $t('perm_system_info_text') }}</span>
            </div>
            <div>
              <Toggle id="settings_system" v-model="userData.permissions.settings_system"/>
            </div>
          </div>
          <div class="flex-center toggle-title" v-if="parseInt(get_user.backoffice_id) === 1">
            <div>
              <p>{{ $t('freight_agreements') }}</p>
              <span>{{ $t('perm_freight_agreements_info_text') }}</span>
            </div>
            <div>
              <Toggle id="settings_account" v-model="userData.permissions.settings_account"/>
            </div>
          </div>
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('ftp') }}</p>
              <span>{{ $t('perm_ftp_info_text') }}</span>
            </div>
            <div>
              <Toggle id="settings_ftp" v-model="userData.permissions.settings_ftp"/>
            </div>
          </div>
        </div>
        <h2 class="m-b-20 page-title">{{ $t('Report') }}</h2>
        <div class="m-b-40 card">
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('report')}}</p>
              <span>{{ $t('perm_report_info_text')}}</span>
            </div>
            <div>
              <Toggle id="report" v-model="userData.permissions.report"/>
            </div>
          </div>
        </div>

        <h2 class="m-b-20 page-title" v-if="parseInt(get_user.backoffice_id) === 1">{{ $t('Finance') }}</h2>
        <div class="m-b-40 card" v-if="parseInt(get_user.backoffice_id) === 1">
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('invoices')}}</p>
              <span>{{ $t('perm_invoices_info_text')}}</span>
            </div>
            <div>
              <Toggle id="vendorInvoices" v-model="userData.permissions.vendor_invoices"/>
            </div>
          </div>
        </div>
        <h2 class="m-b-20 page-title">{{ $t('item_catalog') }}</h2>
        <div class="m-b-40 card">
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('item_catalog')}}</p>
              <span>{{ $t('item_catalog_subtext')}}</span>
            </div>
            <div>
              <Toggle id="items" v-model="userData.permissions.items"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Popup
      v-if="openPopup"
      :popupSmall=true
      :isPopupSubmitDisabled="isPopupSubmitDisabled"
      :showConfirmButton="!deleteUser"
      :showDeleteButton="deleteUser"
      @cancel="togglePopup"
      @deleteAction="deleteUserAction"
      @confirm="submitForm">
      <template v-slot:header>
        <h2>{{ $t('Edit profile') }}</h2>
      </template>
      <div>
        <div class="row" v-if="get_is_admin">
          <div class="col-xs-12">
            <div class="flex-center toggle-title">
              <div class="input-select">
                <label>{{ $t('activate_user')}}</label>
                <span>{{ $t('enable_user_to_login') }}</span>
              </div>
              <div>
                <Toggle id="deactivateUser" v-model="form.is_active" />
              </div>
            </div>
          </div>
        </div>
        <div class="separator medium" v-if="get_user.is_admin"></div>
        <div class="row">
          <div class="col-xs-12 m-b-20" v-if="get_user.is_super_admin">
            <InputSelect
              :multiSelect=true
              :label="$t('Accessible accounts')"
              :preselected="form.accessible_subaccounts"
              @change="selectSubaccounts"
              :options="subacountsList"/>
          </div>
          <div class="col-xs-12 m-b-20" v-if="(get_user.is_admin && !get_stored_user.is_super_admin) || get_user.is_system_user">
            <InputSelect
              :multiSelect=true
              :preselected="form.accessible_for_subaccounts"
              :label="$t('accessible_for_accounts')"
              @change="selectAccessibleForSubaccounts"
              :options="getAllowedSubaccounts" />
          </div>
          <InputText
            :disabled=true
            class="col-xs-6 m-b-20"
            label="E-mail"
            v-model="form.email"
            :rules="{required: true, email: true}" />
          <InputText
            class="col-xs-6 m-b-20"
            :label="$t('Title')"
            v-model="form.function" />
          <InputText
            class="col-xs-6 m-b-20"
            :label="$t('name')"
            v-model="form.first_name"
            :rules="{required: true}" />
          <InputText
            class="col-xs-6 m-b-20"
            :label="$t('Surname')"
            v-model="form.last_name"
            :rules="{required: true}" />
          <PhoneSelect class="col-xs-12" key="userPhone" v-model="form.phone" />
        </div>
        <div class="separator medium"></div>
        <div class="row">
          <div class="col-xs-12">
            <div class="flex-center toggle-title">
              <div>
                <p>{{ $t('Reset password') }}</p>
                <span>{{ $t('This will reset password') }}</span>
              </div>
              <div>
                <Btn
                  class="brand"
                  :icon="{name: 'restore',size: '20'}"
                  :btnText="$t('Reset')"
                  @btnClick="resetPassword" />
              </div>
            </div>
          </div>
        </div>
        <div class="separator medium" v-if="get_is_admin && !get_stored_user.is_admin"></div>
        <div class="row" v-if="get_is_admin && !get_stored_user.is_admin">
          <div class="col-xs-12">
            <div class="flex-center toggle-title">
              <div>
                <p>{{ $t('delete_user') }}</p>
                <span>{{ $t('User will be deleted') }}</span>
              </div>
              <div>
                <Toggle color="red" id="deleteUser" v-model="deleteUser" />
              </div>
            </div>
          </div>
        </div>
      </div>
  </Popup>
</div>
</template>

<script>
/* eslint-disable */
import {mapGetters} from 'vuex';
import Btn from '@/components/elements/buttons';
import ConfirmationBar from '@/components/global/confirmationBar';
import InputText from '@/components/elements/inputs/text.vue';
import Popup from '@/components/global/popup';
import UserCard from '@/components/global/userCard';
import InputSelect from '@/components/elements/inputs/select.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';
import PhoneSelect from '@/components/elements/inputs/phone.vue';
import formValidator from '@/mixins/formValidator';

export default {
  components: {
    Btn,
    ConfirmationBar,
    Popup,
    InputText,
    UserCard,
    InputSelect,
    Toggle,
    PhoneSelect,
  },
  mixins: [formValidator],
  data() {
    return {
      openPopup: false,
      deleteUser: false,
      userRole: '0',
      form: {
        is_super_admin: '0',
        is_admin: '0',
        active_subaccount_id: '',
        is_active: '',
        language: '',
        email: '',
        password: '',
        first_name: '',
        last_name: '',
        function: '',
        return_waybill_action_type: '',
        label_printer_id: '',
        label_format: '',
        goods_type_id: '',
        package_id: '',
        weight_type: '',
        dimension_type: '',
        should_show_freight_prices: '',
        phone: {
          number: '',
          country: '',
        },
        accessible_subaccounts: [],
        accessible_for_subaccounts: []
      },
      showSavebar: false,
      loadUser: false,
      loadPermissions: false,
      userId: '',
      userData: {
        is_super_admin: '',
        is_admin: '',
        permissions: {
          dashboard: false,
          shipment_book_shipment: false,
          shipment_history: false,
          shipment_drafts: false,
          shipment_end_of_day: false,
          unapproved_shipments: false,
          consolidations: false,
          booked_pickup: false,
          not_planned_pickup: false,
          customer: false,
          customer_delivery_address: false,
          settings_import_template: false,
          settings_message: false,
          settings_automations: false,
          settings_package: false,
          settings_printer: false,
          settings_sender: false,
          settings_payer: false,
          settings_smtp: false,
          settings_system: false,
          settings_team: false,
          settings_account: false,
          settings_ftp: false,
          report: false,
          vendor_invoices: false,
          items: false
        }
      }
    };
  },
  computed: {
    ...mapGetters([
      'get_is_admin',
      'get_user',
      'get_stored_user',
      'get_language',
      'get_subaccounts',
    ]),
    isPopupSubmitDisabled() {
      const formWithValidators = [
        {
          formFeild:'email',
          value: this.form.email,
          validators:{required: true, email: true}
        },
        {
          formFeild:'first_name',
          value: this.form.first_name,
          validators:{required: true}
        },
        {
          formFeild:'last_name',
          value: this.form.last_name,
          validators:{required: true}
        },
      ]
      return this.validateInput(formWithValidators);
    },
    getUserRoleOptions() {
      let options = []

      if (this.get_user.is_system_user) {
        options.push({value: '2', 'text': 'Super Admin'})
      }

      options.push({value: '1', text: 'Administrator'}, {value: '0', text: 'Regular user'});

      return options;
    },
    getAllowedSubaccounts() {
      return this.get_subaccounts.filter((acc) => this.get_user.accessible_subaccounts_array.indexOf(String(acc.id)) > -1).map((acc) => ({text: acc.name, value: String(acc.id),}));
    },
    subacountsList() {
      return this.get_subaccounts.map((acc) => ({text: acc.name, value: acc.id,}));
    },
    nameAndBackOption() {
      return this.$route.params.id != undefined ? true : false;
    },
    isEditableProfile() {
      //If user is super admin only owner or system user can change user data
      if ((this.get_user.id != this.get_stored_user.id) && this.get_stored_user.is_super_admin && !this.get_user.is_system_user) {
        return false;
      }

      if( this.get_is_admin || (this.$route.params.id === undefined)) {
        return true;
      } else if( this.$route.params.id == this.get_user.id ) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    this.userId = this.$route.params.id ? this.$route.params.id : localStorage.userId

    this.$store.dispatch('GET_USER', {id: this.userId}).then((res) => {
      this.userData.is_admin = res.is_admin
      this.userData.is_super_admin = res.is_super_admin
      this.userRole = res.is_super_admin ? '2' : res.is_admin ? '1' : '0';
    }).then(() => {
      this.$store.dispatch('GET_USER_PERMISSIONS', {id: this.userId}).then((res) => {
        let temp

        temp = res.find(x => x.acl_route_group === 'dashboard')
        this.userData.permissions.dashboard = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'shipment/book-shipment')
        this.userData.permissions.shipment_book_shipment = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'shipment/history')
        this.userData.permissions.shipment_history = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'shipment/draft')
        this.userData.permissions.shipment_drafts = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'shipment/end-of-day')
        this.userData.permissions.shipment_end_of_day = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'shipment/unapproved-shipments')
        this.userData.permissions.unapproved_shipments = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'shipment/consolidations')
        this.userData.permissions.consolidations = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'pickup/booked')
        this.userData.permissions.booked_pickup = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'pickup/not-planned')
        this.userData.permissions.not_planned_pickup = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'customer/customer')
        this.userData.permissions.customer = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'customer/delivery-address')
        this.userData.permissions.customer_delivery_address = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'settings/import-template')
        this.userData.permissions.settings_import_template = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'settings/message')
        this.userData.permissions.settings_message = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'settings/automations')
        this.userData.permissions.settings_automations = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'settings/package')
        this.userData.permissions.settings_package = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'settings/printer')
        this.userData.permissions.settings_printer = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'settings/sender')
        this.userData.permissions.settings_sender = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'settings/payer')
        this.userData.permissions.settings_payer = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'settings/smtp')
        this.userData.permissions.settings_smtp = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'settings/system')
        this.userData.permissions.settings_system = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'settings/team')
        this.userData.permissions.settings_team = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'settings/account')
        this.userData.permissions.settings_account = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'settings/ftp')
        this.userData.permissions.settings_ftp = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'report')
        this.userData.permissions.report = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'finance/invoices')
        this.userData.permissions.vendor_invoices = temp ? temp.view : false

        temp = res.find(x => x.acl_route_group === 'items/items')
        this.userData.permissions.items = temp ? temp.view : false

        this.$nextTick(() => {
          this.loadPermissions = true;
          this.loadUser = true;
        })
      })

    });
  },
  methods: {
    selectAccessibleForSubaccounts(val) {
      if(val.length > 0){
        this.form.accessible_for_subaccounts = val;
      }
    },
    selectSubaccounts(val) {
      if(val.length > 0){
        this.form.accessible_subaccounts = val;
      }
    },
    showSavebarFunc() {
      this.showSavebar = true;
    },
    cancel() {
      this.showSavebar = false;
    },
    saveData() {
      this.$store.dispatch(`EDIT_USER`, {

        form: {
         // is_admin: this.userData.is_admin,
          is_admin: ['1', '2'].includes(this.userRole),
          is_super_admin: ['2'].includes(this.userRole),
        },
        id: this.userId,
      }).then(() => {
        this.$store.dispatch('GET_USER', {id: this.userId});
        this.$store.dispatch('GET_USER_PERMISSIONS', {id: this.userId});
      });

      // Map users permissions with the KEYs (acl_route_group)
      let data = [
        {
          acl_route_group: 'dashboard',
          view: this.userData.permissions.dashboard,
          edit: this.userData.permissions.dashboard
        },
        {
          acl_route_group: 'shipment/book-shipment',
          view: this.userData.permissions.shipment_book_shipment,
          edit: this.userData.permissions.shipment_book_shipment
        },
        {
          acl_route_group: 'shipment/history',
          view: this.userData.permissions.shipment_history,
          edit: this.userData.permissions.shipment_history
        },
        {
          acl_route_group: 'shipment/draft',
          view: this.userData.permissions.shipment_drafts,
          edit: this.userData.permissions.shipment_drafts
        },
        {
          acl_route_group: 'shipment/end-of-day',
          view: this.userData.permissions.shipment_end_of_day,
          edit: this.userData.permissions.shipment_end_of_day
        },
        {
          acl_route_group: 'shipment/unapproved-shipments',
          view: this.userData.permissions.unapproved_shipments,
          edit: this.userData.permissions.unapproved_shipments
        },
        {
          acl_route_group: 'shipment/consolidations',
          view: this.userData.permissions.consolidations,
          edit: this.userData.permissions.consolidations
        },
        {
          acl_route_group: 'pickup/booked',
          view: this.userData.permissions.booked_pickup,
          edit: this.userData.permissions.booked_pickup
        },
        {
          acl_route_group: 'pickup/not-planned',
          view: this.userData.permissions.not_planned_pickup,
          edit: this.userData.permissions.not_planned_pickup
        },
        {
          acl_route_group: 'customer/customer',
          view: this.userData.permissions.customer,
          edit: this.userData.permissions.customer
        },
        {
          //Use customer permission for delivery address
          acl_route_group: 'customer/delivery-address',
          view: this.userData.permissions.customer,
          edit: this.userData.permissions.customer
        },
        {
          acl_route_group: 'settings/import-template',
          view: this.userData.permissions.settings_import_template,
          edit: this.userData.permissions.settings_import_template
        },
        {
          acl_route_group: 'settings/message',
          view: this.userData.permissions.settings_message,
          edit: this.userData.permissions.settings_message
        },
        {
          acl_route_group: 'settings/automations',
          view: this.userData.permissions.settings_automations,
          edit: this.userData.permissions.settings_automations
        },
        {
          acl_route_group: 'settings/package',
          view: this.userData.permissions.settings_package,
          edit: this.userData.permissions.settings_package
        },
        {
          acl_route_group: 'settings/printer',
          view: this.userData.permissions.settings_printer,
          edit: this.userData.permissions.settings_printer
        },
        {
          acl_route_group: 'settings/sender',
          view: this.userData.permissions.settings_sender,
          edit: this.userData.permissions.settings_sender
        },
        {
          acl_route_group: 'settings/payer',
          view: this.userData.permissions.settings_payer,
          edit: this.userData.permissions.settings_payer
        },
        {
          acl_route_group: 'settings/smtp',
          view: this.userData.permissions.settings_smtp,
          edit: this.userData.permissions.settings_smtp
        },
        {
          acl_route_group: 'settings/system',
          view: this.userData.permissions.settings_system,
          edit: this.userData.permissions.settings_system
        },
        {
          acl_route_group: 'settings/team',
          view: this.userData.permissions.settings_team,
          edit: this.userData.permissions.settings_team
        },
        {
          acl_route_group: 'settings/account',
          view: this.userData.permissions.settings_account,
          edit: this.userData.permissions.settings_account
        },
        {
          acl_route_group: 'settings/ftp',
          view: this.userData.permissions.settings_ftp,
          edit: this.userData.permissions.settings_ftp
        },
        {
          acl_route_group: 'report',
          view: this.userData.permissions.report,
          edit: this.userData.permissions.report
        },
        {
          acl_route_group: 'finance/invoices',
          view: this.userData.permissions.vendor_invoices,
          edit: this.userData.permissions.vendor_invoices
        },
        {
          acl_route_group: 'items/items',
          view: this.userData.permissions.items,
          edit: this.userData.permissions.items
        },
      ]

      this.$store.dispatch(`EDIT_USER_PERMISSIONS`, {
        form: data,
        id: this.userId,
      }).then(() => {
        this.showSavebar = false;
      });

    },
    routeIt() {
      this.$router.push('/settings/platform/team');
    },
    togglePopup() {
      this.openPopup = !this.openPopup;
    },
    submitForm() {
      let subaccountId = '';
      if(this.form.accessible_subaccounts.indexOf(String(this.form.active_subaccount_id)) > -1){
        subaccountId = String(this.form.active_subaccount_id);
      } else {
        subaccountId = String(this.form.accessible_subaccounts[0]);
        this.$store.dispatch(
          'STORE_ACTIVE_SUBACCOUNT',
          this.get_subaccounts.filter((subaccount) => subaccount.id == subaccountId)[0]
        );
      }

      this.$store.dispatch(`EDIT_USER`, {
        form: { ...this.form, phone: this.form.phone.number, active_subaccount_id: subaccountId},
        id: this.get_stored_user.id,
      }).then(() => {
        this.openPopup = false;
        this.$store.dispatch('GET_USER', {id: this.get_stored_user.id});
        this.$store.dispatch('GET_PROFILE').then((profileRes) => {
          this.$store.dispatch('STORE_USER', profileRes);
        });
      });
    },
    openEditPopup() {
      this.togglePopup()
      this.form = {
        is_super_admin: this.get_stored_user.is_super_admin,
        is_admin: this.get_stored_user.is_admin,
        is_active: this.get_stored_user.is_active,
        active_subaccount_id: this.get_stored_user.active_subaccount_id,
        language: this.get_stored_user.language,
        email: this.get_stored_user.email,
        first_name: this.get_stored_user.first_name,
        last_name: this.get_stored_user.last_name,
        function: this.get_stored_user.function,
        return_waybill_action_type: this.get_stored_user.return_waybill_action_type,
        label_printer_id: this.get_stored_user.label_printer_id,
        label_format: this.get_stored_user.label_format,
        goods_type_id: this.get_stored_user.goods_type_id,
        package_id: this.get_stored_user.package_id,
        weight_type: this.get_stored_user.weight_type,
        dimension_type: this.get_stored_user.dimension_type,
        should_show_freight_prices: this.get_stored_user.should_show_freight_prices,
        phone: {
          number: this.get_stored_user.phone,
          country: '',
        },
        accessible_subaccounts: this.get_stored_user.accessible_subaccounts_array,
        accessible_for_subaccounts: this.get_stored_user.accessible_for_subaccounts
      }
    },
    resetPassword() {
      this.$store.dispatch('FORGOT_PASSWORD', {email: this.get_stored_user.email}).then(() => {
        this.openPopup = false;
        this.$store.commit('SHOW_NOTIFICATION_BAR', {
          message: this.$t('reset_password_notification_msg'),
          type: 'success-window',
        });
      });
    },
    deleteUserAction() {
      this.$store.dispatch('DELETE_USER', this.get_stored_user.id).then(() => {
        this.openPopup = false;
        this.$router.push('/settings/platform/team')
      });
    },
  },
  watch: {
    userRole: {
      handler(){
        if(this.loadPermissions && this.loadUser){
          this.showSavebar = true;
        };
      },
      deep: true,
    },
    userData: {
      handler(){
        if(this.loadPermissions && this.loadUser){
          this.showSavebar = true;
        };
      },
      deep: true,
    },
  },
};
</script>
